/**
 * 푸터(Bottom) 및 회원 결제 화면 판매자 정보에 사용하는 머스트무브 법적 고지
 * (src/scenes/global/Bottom.tsx 와 동일 내용 유지)
 */
export const mustMoveCompanyLegalInfo = {
    /** 법인 표기명 (브랜드용) */
    tradeName: '머스트무브 주식회사',
    /** 사업자 등록증상의 공식 상호명 */
    officialTradeName: '주식회사 머스트무브',
    representativeName: '주상화',
    phone: '010-5726-7576',
    address: '서울특별시 영등포구 당산로 241, 4층 406호(당산동, 유니언타운 당산)',
    businessRegistrationNumber: '119-88-01131',
    /** 통신판매업 신고번호 */
    mailOrderSalesReportNumber: '2021-서울강남-06720',
    customerInquiry: '라포 카카오 채널',
} as const;
